module.exports = __webpack_public_path__ + "static/confirm-order-bfeb30a676aea494251db85e513db8ab.mp4";